import {Component} from 'preact';
import SVG from 'react-inlinesvg'

import style from './style.scss'

class CategoryButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            opacity: 0
        }
    }

    componentDidMount() {
        this.setState({opacity: 1})
    }

    render() {
        const {opacity} = this.state
        //Must be null, otherwise the button will be clickable.
        const visibility = this.props.imgSrc ? null : 'hidden';
        return (
            <div className={style.CategoryContainer} style={{visibility:visibility, opacity: opacity}}>
                <div className={style.ClickSurface} onClick={this.props.onClick}>
                    <div className={style.ImageWrapper}>
                        <SVG className={style.CategoryIcon} src={this.props.imgSrc || ''} style={{fill: this.props.color}}/>
                    </div>
                    <div className={style.CategoryText}>{this.props.catName}</div>
                </div>
            </div>
        )
    }
}

export default CategoryButton;



// WEBPACK FOOTER //
// ./routes/HelpDesk/CategoryButton/CategoryButton.js